import { PagePayload } from '@core/interface/core';
import {
  AddDocumentPayload,
  AddDocumentResponse,
  DeletedDocument,
  DocumentError,
  DocumentItem,
  DocumentResponse,
  EditDocumentResponse,
} from '@core/interface/employee-document';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const DocumentActions = createActionGroup({
  source: 'Document',
  events: {
    'Load Documents': props<PagePayload>(),
    'Load Documents Success': props<DocumentResponse>(),
    'Load Documents Failure': props<DocumentError>(),
    'Add Document': props<AddDocumentPayload>(), // metadata only
    'Add Document Success': props<AddDocumentResponse>(),
    'Update Document Success': props<EditDocumentResponse>(),
    'Add Document Failure': props<DocumentError>(),
    'Update Document Failure': props<DocumentError>(),
    'Delete Document': props<{ id: number }>(),
    'Delete Document Success': props<DeletedDocument>(),
    'Delete Document Failure': props<DocumentError>(),
    'Reset Delete Status': emptyProps(),
    'Reset Documents': emptyProps(),
  },
});
